"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.THEME_PROPS_PATH = exports.THEMED_DEFAULT_VALUE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
function cov_2il9b8t867() {
  var path = "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/constants.js";
  var hash = "383d632357b5be50cbcbcb493b686c95fdc1cd2b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/constants.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 36
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 32
        },
        end: {
          line: 20,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "383d632357b5be50cbcbcb493b686c95fdc1cd2b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2il9b8t867 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2il9b8t867();
/* eslint-disable import/prefer-default-export */
var THEMED_DEFAULT_VALUE = exports.THEMED_DEFAULT_VALUE = (cov_2il9b8t867().s[0]++, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, {
  tabActiveColor: '#00a6dc',
  tabsBlockTextColor: '#00a6dc'
}), _themeProvider.TicketShopTheme.EVOLUTION, {
  tabActiveColor: _themeMapper.evolutionTheme.tabs.items.active.color,
  tabsBlockTextColor: _themeMapper.evolutionTheme.tabs.items.active.color
}));
var THEME_PROPS_PATH = exports.THEME_PROPS_PATH = (cov_2il9b8t867().s[1]++, {
  tabActiveColor: 'theme.selectedTabTextColor',
  tabsBlockTextColor: 'theme.tabTextColor',
  textColor: 'theme.tabTextColor'
});